import React, { useEffect, useState } from "react";
import ProviderCard from "../ProviderCard";
import classes from "./provider-card-modal.module.scss";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../utils/LoadingIndicator";
import { Modal, Box, } from "@mui/material";


const ProviderCardModal = ({  open,onClose }) => {

    const { isLoading, providerSearchData} = useSelector((state) => state.provider);
    const [providerData, setProviderData] = useState({})

    useEffect(() => {
        if(providerSearchData?.provider?.length > 0)
            setProviderData(providerSearchData?.provider[0])
    },[providerSearchData])

    return (
        <>
        { isLoading ? <LoadingIndicator context="warm" fullScreen={false} /> : (
        <Modal open={open} onClose={onClose} className={classes["modal"]} sx={{
            "& .MuiBackdrop-root": { backgroundColor: "rgb(255, 255, 255)"}, // Light backdrop
          }} >
            <div className={classes["modal-content"]}>
                <button className={classes["close"]} onClick={onClose} aria-label="Close">✕</button>
                <div className={classes["provider-card"]} >
                    <ProviderCard details={providerData} />
                </div>
            </div>
        </Modal>
        ) }
        </>
    );
};

export default ProviderCardModal;